  export class PhysicalActivityOverviewChartDto {
      [Key: string]: {
        logs: {},
        completeActivityTime: number,
        activitiesEntryCount: number,
        activityStatus: string
      };
  }

  export class PhysicalActivityWeekChartDto {
      data: {
        [Key: string]: {
          logs: {},
          completeActivityTime: number,
          activitiesEntryCount: number,
          activityStatus: string
        }
      };
      status: string;
      colorClass: string;
      completeActivityTime: number;
  }

  export class PhysicalActivityTrendChartDto {
      name: string;
      series: [];
      completeActivityTime: number;
      goalReachAmount: number;
      isGoalReached: boolean;
  }

  export class PhysicalActivityIntensityChartDto {
    name: string;
    series: [];
    isGoalReached: boolean;
    completeActivityTime: number;
    goalReachAmount: number;
  }
